import React from 'react';
import { Dialog } from '@reach/dialog';

import useLaneSheetHeatAthletesPopup from './UseLaneSheetHeatAthletesPopup';

import LaneSheetHeatAthletesForm from '../components/forms/LaneSheetHeatAthletesForm';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';
import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';
import style from './LaneSheetHeatAthletesPopup.module.css';

const LaneSheetHeatAthletesPopup = ({ laneSheetHeat, displayPopup, onClosePopup }) => {
  const {
    isLoading,
    numberOfLanes,
    startingLaneNumber,
    meetEventAthletes,
    heatAthletes,
    onSubmitFormCallback,
    onEditAthlete
  } = useLaneSheetHeatAthletesPopup(laneSheetHeat, onClosePopup);

  return (
    <Dialog
      isOpen={displayPopup === true}
      allowPinchZoom={true}
      aria-label={'Lane Sheet Configuration'}
      className={style.LaneSheetConfig}>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H2 excludeBar={true} className='text-center'>Lane Sheet Configuration</Headings.H2>
        </div>
      </div>
      <hr />
      <div className='row'>
        <div className='col-xs-12'>
          <p className={global.HeaderText}><b>Event Name</b> {laneSheetHeat.eventName || ''}  </p>
        </div>
        <div className='col-xs-12'>
          <p className={global.HeaderText}><b>Heat - Heat Date - Session Type:</b> {laneSheetHeat.heatNumber || ''} - {laneSheetHeat.heatDate ? formatDate(laneSheetHeat.heatDate) : ''} - {laneSheetHeat.sessionTypeName || ''} </p>
        </div>
      </div>
      <LaneSheetHeatAthletesForm
        numberOfLanes={numberOfLanes}
        startingLaneNumber={startingLaneNumber}
        meetEventAthletes={meetEventAthletes}
        heatAthletes={heatAthletes}
        onSubmitFormCallback={onSubmitFormCallback}
        onEditAthlete={onEditAthlete}
        onSecondaryButtonClicked={onClosePopup} />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Dialog>
  );
};

export default LaneSheetHeatAthletesPopup;